import { useEffect, useState } from "react";
import httpUtils from "@/utils/httpUtils";
import { env } from "@/next.config";

export const useCountry = (props) => {
  if (props === undefined) {
    props = {};
  }
  const { searchVCDropdown, searchStartupDropdown } = props;
  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCountries = async () => {
    setIsLoading(true);
    try {
      let params = {
        dropdown: true,
      };

      if (searchVCDropdown) {
        params = {
          searchVCDropdown: true,
        };
      }

      if (searchStartupDropdown) {
        params = {
          searchStartupDropdown: true,
        };
      }
      const response = await httpUtils.get(`${env.API_VERSION}/country`, {
        params,
      });
      setCountries(response.data);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (countries.length === 0) {
      fetchCountries();
    }
  }, []);

  return { countries, fetchCountries, isLoading };
};
